import { render } from "./FinanciLogo.vue?vue&type=template&id=35472eaa&scoped=true"
import script from "./FinanciLogo.vue?vue&type=script&lang=js"
export * from "./FinanciLogo.vue?vue&type=script&lang=js"

import "./FinanciLogo.vue?vue&type=style&index=0&id=35472eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35472eaa"]])

export default __exports__